<template>
  <div>
    <v-card
      flat
      dense
    >
      <v-form ref="form" lazy-validation>
        <v-flex xs12>
          <v-layout row wrap align-center>
            <v-flex xs12 md12
                    v-if="this.payment_option==='ANCIC'"
                    >
              <v-select
                outlined
                v-model="induction_details"
                item-text="details"
                item-value="id"
                class="mx-2"
                :items="induction_items"
                label="Induction Details"
                required
                @change="selected_induction"
              ></v-select>
              <v-text-field
                :min="0"
                type="number"
                v-model="amount"
                label="Amount"
                class="mx-2"
                required
                :rules="rules.default_max_45_character_and_no_empty_rule"
              ></v-text-field>
              <v-text-field
                v-model="year_of"
                label="Year of"
                class="mx-2"
                required
                readonly
                :rules="rules.default_max_45_character_and_no_empty_rule"
              ></v-text-field>
              <v-text-field
                v-model="location"
                label="Location"
                class="mx-2"
                required
                readonly
                :rules="rules.default_max_255_character_and_no_empty_rule"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12 v-else-if="this.payment_sub_option === 'ACA FELLOWS'||this.payment_sub_option === 'ADOPT A TREE'||this.payment_sub_option === 'GUARDIANS OF HOPE'||this.payment_sub_option === 'LIVELIHOOD DONATION'
            ||this.payment_sub_option === 'ENDOWMENT' ||this.payment_sub_option === 'SPONSORSHIP' ||this.payment_sub_option === 'YOUTH DONATION'||this.payment_sub_option === 'COMMUNITY DONATION'||this.payment_sub_option === 'HEALTH DONATION'
            ||this.payment_sub_option === 'EDUCATION DONATION'||this.payment_sub_option === 'ENVIRONMENT DONATION'
            ||this.payment_sub_option === 'YOUTH MEMBERSHIP'||this.payment_sub_option === 'CALAMITY FUND'">
              <v-text-field
                v-if="!is_have_other_payment_pending"
                :min="0"
                type="number"
                v-model="amount"
                label="Amount"
                class="mx-2"
                required
                :rules="rules.default_max_45_character_and_no_empty_rule"
              ></v-text-field>
              <v-select
                v-if="is_have_other_payment_pending"
                outlined
                v-model="year_of"
                item-text="year_of"
                item-value="id"
                class="mx-2"
                :items="year_of_items"
                label="Year of"
                required
                @change="selected_year"
              ></v-select>
              <v-text-field
                v-if="is_have_other_payment_pending"
                :min="0"
                type="number"
                v-model="amount"
                label="Amount"
                class="mx-2"
                required
                :rules="rules.default_max_45_character_and_no_empty_rule"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12 v-else>
              <div v-if="year_of_items.length===0 && this.payment_option === 'Members Payment'">
                <v-text-field
                  :min="0"
                  type="number"
                  v-model="amount"
                  label="Amount"
                  class="mx-2"
                  required
                  :rules="rules.default_max_45_character_and_no_empty_rule"
                  readonly
                ></v-text-field>
              </div>
              <div v-else>
                <v-select
                  outlined
                  v-model="year_of"
                  item-text="year_of"
                  item-value="id"
                  class="mx-2"
                  :items="year_of_items"
                  label="Year of"
                  required
                  @change="selected_year"
                ></v-select>
                <v-text-field
                  :min="0"
                  type="number"
                  v-model="amount"
                  label="Amount"
                  class="mx-2"
                  required
                  :rules="rules.default_max_45_character_and_no_empty_rule"
                  readonly
                ></v-text-field>
              </div>
            </v-flex>
            <!-- alert -->
            <v-col cols="12" v-show="alert">
              <v-alert
                color="warning"
                text
                class="mb-0"

              >
                <div class="d-flex align-start">
                  <v-icon color="warning">
                    {{ icons.mdiAlertOutline }}
                  </v-icon>

                  <div class="ms-3">
                    <p class="text-base font-weight-medium mb-1">
                      {{ alert_message }}
                    </p>
                  </div>
                </div>
              </v-alert>
            </v-col>

            <v-col cols="12">
              <v-btn
                color="primary"
                class="me-3 mt-4"
                @click="save_payments"
                v-if="!saving"
              >
                Save changes
              </v-btn>
              <v-progress-circular
                :size=50
                :width="5"
                color="primary"
                indeterminate
                v-else
              ></v-progress-circular>
            </v-col>
          </v-layout>
        </v-flex>
      </v-form>
    </v-card>
    <snack-bar-dialog
      :snackbar_flag="this.snackbar"
      :color="this.snackbar_color"
      :snackbar_text="this.snackbar_text"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {mdiAlertOutline, mdiCloudUploadOutline} from "@mdi/js";
import moment from 'moment'
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'

export default {
  props: {
    collector_id: Number,
    payment_for: String,
    payment_option: String,
    payment_sub_option:String,
    option_search: String,

    selected_search_items: Object,

    deposit_slip_id: Number,
    balance: Number,
  },
  components: {
    snackBarDialog,
  },
  setup() {
    return {
      icons: {
        mdiAlertOutline,
        mdiCloudUploadOutline,
      },
    }
  },
  data() {
    return {
      saving: false,
      is_have_other_payment_pending: false,
      alert: false,
      alert_message: '',
      year_of: '',
      location: '',

      amount: 0,
      amount_due: [],
      year_of_items: [],

      induction_details: '',
      induction_items: [],
    }
  },
  watch: {
    selected_search_items: function () {
      this.selected_payment_for()
    },
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('authentication', ['branch_id']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text']),
    ...mapGetters('authentication', ['month_of']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('members_payment', ['register_new_members_payment', 'register_new_other_payment']),
    ...mapActions('district', ['register_new_district_payment']),
    ...mapActions('induction_history_payments', ['create_induction_payment']),
    ...mapActions('induction_tickets_payments', ['create_induction_ticket_payment']),
    selected_payment_for() {
      this.is_have_other_payment_pending=false
      this.amount = '0'
      this.induction_items = []
      if (this.payment_sub_option === 'Induction Payment') {
        this.amount = ''
        if (this.selected_search_items != null && this.selected_search_items != undefined) {
          this.induction_items = this.selected_search_items.unpaid_induction
        }
      }
      if (this.payment_sub_option === 'Tickets Payment') {
        this.amount = ''
        if (this.selected_search_items != null && this.selected_search_items != undefined) {
          this.induction_items = this.selected_search_items.tickets
        }
      }
      if (this.payment_option === 'Members Payment') {
        this.amount = ''
        if (this.selected_search_items != null && this.selected_search_items != undefined) {
          this.year_of_items = this.selected_search_items.unpaid_members_payment
          if (this.year_of_items.length===0){
            this.amount = '1000'
          }
        }
      }
      if (this.payment_option === 'District Payment') {
        this.amount = ''
        if (this.selected_search_items != null && this.selected_search_items != undefined) {
          this.year_of_items = this.selected_search_items.unpaid_district_payment
        }
      }
      if (this.payment_sub_option === 'ADOPT A TREE'||this.payment_sub_option === 'GUARDIANS OF HOPE') {
        this.amount = ''
        if (this.selected_search_items != null && this.selected_search_items != undefined) {
          this.year_of_items = this.selected_search_items.unpaid_others_payment
          if (this.year_of_items.length>0){
            this.is_have_other_payment_pending=true
          }
        }
      }
    },
    selected_induction() {
      var index = this.induction_items.map(function (x) {
        return x.id;
      }).indexOf(this.induction_details)
      if (index != -1) {
        this.year_of = this.induction_items[index].year_of + ''
        this.location = this.induction_items[index].location
      }
    },
    selected_year() {
      var index = this.year_of_items.map(function (x) {
        return x.id;
      }).indexOf(this.year_of)
      if (index != -1) {
        this.amount = this.year_of_items[index].amount
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    save_payments() {
      this.saving = true
      this.alert = false
      if (this.$refs.form.validate()) {
        var proceed = true;
        var total_amount_to = this.amount
        if (this.balance <= 0
          || (this.balance - total_amount_to) < -100) {
          proceed = false;
          this.alert = true
          this.alert_message = 'Please Load Deposit Slip First'
          this.saving = false
        }
        //if no error above then proceed
        if (proceed) {
          if (this.payment_sub_option === 'Induction Payment') {
            this.create_induction_payment({
              member_id: this.selected_search_items.member_id,
              induction_id: this.induction_details,
              deposit_slip_id: this.deposit_slip_id,
              amount: this.amount,
              year_of: this.year_of,
              location: this.location.toUpperCase(),
              balance: this.balance - this.amount,
              collector_id: this.collector_id
            })
              .then(() => {
                this.change_snackbar({
                  show: true,
                  color: 'success',
                  text: this.payment_sub_option + ' SUCCESSFULLY !',
                })
                this.$emit('collector', this.collector_id)
                this.saving = false
              })
              .catch(error => {
                this.alert = true
                this.alert_message = error
                this.saving = false
              })
          } else if (this.payment_sub_option === 'Tickets Payment') {
            this.create_induction_ticket_payment({
              induction_ticket_id: this.induction_details,
              deposit_slip_id: this.deposit_slip_id,
              amount: this.amount,
              year_of: this.year_of,
              location: this.location.toUpperCase(),
              balance: this.balance - this.amount,
              collector_id: this.collector_id
            })
              .then(() => {
                this.change_snackbar({
                  show: true,
                  color: 'success',
                  text: this.payment_sub_option + ' SUCCESSFULLY !',
                })
                this.$emit('collector', this.collector_id)
                this.saving = false
              })
              .catch(error => {
                this.alert = true
                this.alert_message = error
                this.saving = false
              })
          } else if (this.payment_option === 'District Payment') {
            this.register_new_district_payment({
              id: this.year_of,
              branch_id: this.branch_id,
              district_id: this.selected_search_items.id,
              deposit_slip_id: this.deposit_slip_id,
              amount: this.amount,
              balance: this.balance - this.amount,
              collector_id: this.collector_id
            })
              .then(() => {
                this.change_snackbar({
                  show: true,
                  color: 'success',
                  text: this.payment_option + ' SUCCESSFULLY !',
                })
                this.$emit('collector', this.collector_id)
                this.saving = false
              })
              .catch(error => {
                this.alert = true
                this.alert_message = error
                this.saving = false
              })
          } else if (this.payment_sub_option === 'ACA FELLOWS' || this.payment_sub_option === 'ADOPT A TREE' || this.payment_sub_option === 'GUARDIANS OF HOPE' || this.payment_sub_option === 'LIVELIHOOD DONATION'
            || this.payment_sub_option === 'ENDOWMENT'||this.payment_sub_option === 'SPONSORSHIP' || this.payment_sub_option === 'YOUTH DONATION' || this.payment_sub_option === 'COMMUNITY DONATION' || this.payment_sub_option === 'HEALTH DONATION'
            || this.payment_sub_option === 'EDUCATION DONATION' || this.payment_sub_option === 'ENVIRONMENT DONATION'
            ||this.payment_sub_option === 'YOUTH MEMBERSHIP'||this.payment_sub_option === 'CALAMITY FUND') {
            this.register_new_other_payment({
              id: this.year_of,
              branch_id: this.branch_id,
              district_id: this.option_search === 'District' ? this.selected_search_items.id : null,
              member_id: this.option_search === 'Member' ? this.selected_search_items.id : null,
              organization_id: this.option_search === 'Others' ? this.selected_search_items.id : null,
              deposit_slip_id: this.deposit_slip_id,
              amount: this.amount,
              balance: this.balance - this.amount,
              collector_id: this.collector_id,
              remarks: this.payment_sub_option
            })
              .then(() => {
                this.change_snackbar({
                  show: true,
                  color: 'success',
                  text: this.payment_sub_option + ' SUCCESSFULLY !',
                })
                this.$emit('collector', this.collector_id)
                this.saving = false
              })
              .catch(error => {
                this.alert = true
                this.alert_message = error
                this.saving = false
              })
          } else {
            this.register_new_members_payment({
              id: this.year_of,
              branch_id: this.branch_id,
              member_id: this.selected_search_items.id,
              deposit_slip_id: this.deposit_slip_id,
              amount: this.amount,
              balance: this.balance - this.amount,
              collector_id: this.collector_id
            })
              .then(() => {
                this.change_snackbar({
                  show: true,
                  color: 'success',
                  text: this.payment_option + ' SUCCESSFULLY !',
                })
                this.$emit('collector', this.collector_id)
                this.saving = false
              })
              .catch(error => {
                this.alert = true
                this.alert_message = error
                this.saving = false
              })
          }
        }
      } else {
        this.alert = true
        this.alert_message = 'Please Fill up the field/s'
        this.saving = false
      }
    },
  }
}
</script>
